import { useUser } from 'hooks/useUser';
import { UserAuthProvider } from 'types/state';

export const useUserAuthProvider = (): null | UserAuthProvider => {
  const user = useUser();

  if (user && user.accountInfo) {
    return user.accountInfo.authProvider;
  }

  return null;
};
